import { Component, Input } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';

@Component({
  selector: 'md-cash-vested',
  template: require('./cash-vested.component.html'),
  styles: [require('./cash-vested.component.scss')]
})

export class CashVestedComponent {
  @Input() bankRate: number;
  @Input() isCashVested: boolean;

  constructor(modal: ModalService) {
    this.modal = modal;
  }

  openCashVestedModal() {
    const modal = {
      modalType: 'cashVested'
    };
    this.modal.generic(modal);
  }

}
